import { getEffectivePackageByEquipment, type ResolvedPackageDto } from '@/api/package-resolver';
import { retryUpTo } from '@/lib/query-retry';
import { useQuery } from '@tanstack/react-query';

/**
 * useEffectivePackageByEquipment — E-105 Phase 2 S10 MVP.
 *
 * Equipment ID-ből resolve-olja az effective csomagot. A backend
 * kikeresi a productId + machineCategoryId-t a RentalEquipment-ből.
 */
export function useEffectivePackageByEquipment(
  equipmentId: string | undefined,
  packageType?: string
) {
  const enabled = !!equipmentId;

  const query = useQuery({
    queryKey: ['package-resolver', 'effective-by-equipment', equipmentId, packageType ?? null],
    queryFn: async () => {
      if (!equipmentId) return null;
      return getEffectivePackageByEquipment({ equipmentId, packageType });
    },
    enabled,
    staleTime: 60_000,
    retry: retryUpTo(1),
  });

  return {
    effectivePackage: query.data as ResolvedPackageDto | null | undefined,
    isLoading: query.isLoading && enabled,
    error: query.error?.message ?? null,
  };
}
